import {
  fieldToLabelMap,
  filterMenuItems,
  backofficeFilterMenuItems,
} from "@/v2/features/explore/filters/filter.utils";

// Custom sort for tracker columns
export const customColumnSort = (a: any, b: any) => {
  // 1. Captured always first
  if (a.name === "Captured") return -1;
  if (b.name === "Captured") return 1;

  // 2. hidden (Ignore) always last
  if (a.stage === "hidden" && b.stage !== "hidden") return 1;
  if (a.stage !== "hidden" && b.stage === "hidden") return -1;

  // 3. to_do columns (excluding Captured) next
  if (a.stage === "to_do" && b.stage !== "to_do") return -1;
  if (a.stage !== "to_do" && b.stage === "to_do") return 1;

  // 4. in_progress columns next
  if (a.stage === "in_progress" && b.stage !== "in_progress") return -1;
  if (a.stage !== "in_progress" && b.stage === "in_progress") return 1;

  // 5. done columns last (before hidden)
  if (a.stage === "done" && b.stage !== "done") return 1;
  if (a.stage !== "done" && b.stage === "done") return -1;

  // Otherwise, keep original order or use order field if present
  if (a.order !== undefined && b.order !== undefined) {
    return a.order - b.order;
  }
  return 0;
};

// Helper to format rules as in the table
export function extractRulesForBadges(matchRules?: any): string[] {
  if (!matchRules || !matchRules.and || !Array.isArray(matchRules.and))
    return [];
  return matchRules.and.map((rule: any) => {
    for (const menu of [...filterMenuItems, ...backofficeFilterMenuItems]) {
      const found = menu.options.find(
        (opt) => JSON.stringify(opt.value) === JSON.stringify(rule)
      );
      if (found) {
        const fieldLabel = fieldToLabelMap[menu.field] || menu.field;
        return `${fieldLabel} is ${found.label}`;
      }
    }
    const keys = Object.keys(rule);
    if (keys.length === 1) {
      const field = keys[0];
      const condition = rule[field];
      const fieldLabel = fieldToLabelMap[field] || field;
      if (condition.eq) {
        return `${fieldLabel} is ${condition.eq}`;
      } else if (condition.gt) {
        return `${fieldLabel} > ${condition.gt}`;
      } else if (condition.lt) {
        return `${fieldLabel} < ${condition.lt}`;
      } else if (condition.gte) {
        return `${fieldLabel} ≥ ${condition.gte}`;
      } else if (condition.lte) {
        return `${fieldLabel} ≤ ${condition.lte}`;
      } else if (condition.ne) {
        return `${fieldLabel} ≠ ${condition.ne}`;
      }
    }
    return "Custom rule";
  });
}
